import React from "react";
import { QRCodeCanvas } from 'qrcode.react';
import OverView from './pages/Overview/Overview';
import OverView2 from './pages/Overview/overview2'
import PlanView from './pages/PlanView/PlanView';
import CustomView from './pages/CustomView/CustomView';
import ElevationDimensions from './pages/Elevation1/Elevation1';
import ElevationMaterial from './pages/Elevation2/Elevation2';
import ElevationInternals from './pages/Elevation3/Elevation3';
import InstructionPage from './pages/InstructionPages/InstructionPage';
import Appliances from './pages/Appliances/Appliance';
import ElevationElectricals from './pages/elevationElectrinics/electricalElevation';
import PlumbingElectricals from './pages/plumbing/plumbingElevation';
import LightingOverView from './pages/lightingPages/lightingOverview';
import LightingPlan from './pages/lightingPages/lightsPlan';
import PaintingElevation from './pages/painting/paintingElevation';
import BespokePage from './pages/bespoke/bespoke';
import CustomerDetailsContainer from './customerDetailsContainer';
import { connect } from "react-redux";
import {setPageNotes, init, updateFabric} from '../actions/wizard';
import ErrorComponent from "../components/ErrorComponent";
import WaterMark from "../components/WaterMark";
import Flooring from './pages/flooring/flooring';
import CounterTop from './pages/counterTop/counterTopPage';
import ModuleList from './pages/ModuleList/ModuleList';
import StandardInstructionPage from "./pages/standardInstruction/StandardInstruction";
import CrossSection from "./pages/CrossSection/CrossSection";
import SiteDetail from "./pages/SiteDetail/SiteDetail";
import { debounce } from "helpers/helper";
import ElevationGasOutlet from "./pages/gasOutletElevation/gasOutletElevation";
import OtherServices from "./pages/Services/OtherServices";
import ElevationShutterExtension from "./pages/Elevation2/ShutterExtension";
import FalseCeilingReflectedView from "./pages/FalseCeiling/FalseCeilingReflectedView";
import FalseCeilingSectionView from "./pages/FalseCeiling/FalseCeilingSectionView";
import FalseCeilingPlanView from "./pages/FalseCeiling/FalseCeilingPlanView";
import FalseCeilingPaintView from "./pages/FalseCeiling/FalseCeilingPaintView";
import FalseCeilingOverView from "./pages/FalseCeiling/FalseCeilingOverView";
import WallpaperBespoke from "./pages/bespoke/wallpaperBespoke";
import PaintingBespoke from "./pages/bespoke/paintingBespoke"
import FlooringBespoke from "./pages/bespoke/flooringBespoke";
import {ReactComponent as LayerIcon} from '../assets/icons/layer.svg'

import { enableLayering } from "../actions/wizard";
import FalseCeilingLightingView from "./pages/FalseCeiling/FalseCeilingLightingView";
import FalseCeilingElectricalView from "./pages/FalseCeiling/FalseCeilingElectricalView";
import FalseCeilingElectricalLoopingView from "./pages/FalseCeiling/FalseCeilingElectricalLoopingView";
import LooseFurniture from "./pages/LooseFurnitures/LooseFurniture";
import DadoTiles from "./pages/DadoTiles/DadoTiles";

//Custom False Ceiling
import CustomFalseCeilingOverview from "./pages/CustomFalseCeilingPage/CustomFalseCeilingOverview";
import CustomFalseCeilingPlan from "./pages/CustomFalseCeilingPage/CustomFalseCeilingPlan";
import CustomFalseCeilingSection from "./pages/CustomFalseCeilingPage/CustomFalseCeilingSection";
import CustomFalseCeilingLightLayout from "./pages/CustomFalseCeilingPage/CustomFalseCeilingLightLayout";
import CustomFalseCeilingLoopingLayout from "./pages/CustomFalseCeilingPage/CustomFalseCeilingLoopingLayout";
import CustomFalseCeilingSOW from "./pages/CustomFalseCeilingPage/CustomFalseCeilingElecticals";
import { CustomerFalseCeilingTypes } from './pages/CustomFalseCeilingPage/CustomFalseCeilingConstants';

// New Demolition Pages
import DemolitionServicesRoom from "./pages/DemolitionServices/DemolitionServicesRoom";

// New Civil work Pages 
import CivilWorkServices from "./pages/CivilWorkServices/CivilWorkServices";
import CivilFloorMarbleLaying from "./pages/CivilWorkServices/CivilFloorMarbleLaying";
import CivilFloorTileLaying from "./pages/CivilWorkServices/CivilFloorTileLaying";
import CivilWallTileLaying from "./pages/CivilWorkServices/CivilWallTileLaying";

// New Pages
import WallElectrical from "./pages/NewCustomPages/WallElectrical";
import NewLightingOverview from "./pages/NewCustomPages/NewLightingOverview";
import WoodenFlooring from "./pages/NewCustomPages/WoodenFlooring";
import WallPainting from "./pages/NewCustomPages/WallPainting";
import ScopeOfWorkTable from "./pages/ScopeOfWorkTable/ScopeOfWorkTable";

import RightClickMenu from "./RightClickMenu/RightClickMenu";
import WallPaneling from "./pages/WallPaneling/WallPaneling";
import CounterTopSOW from "./pages/counterTop/CounterTopSOW/CounterTopSOW";

// Curtains Pages
import Curtains from "./pages/Curtains/Curtains";
import CurtainsYellow from "./pages/Curtains/CurtainsYellow";
import CurtainsDecor from "./pages/Curtains/CurtainsDecor";
import CurtainsAumbre from "./pages/Curtains/CurtainsAumbre";

import RFQPage from "./pages/RFQ/RFQ";
import DQCPage from "./pages/DQC/DQC";

class PageContainer extends React.Component<any, any>{
    constructor(props){
       super(props);
       this.state={
           notes:"",
           menuPosition:{x:0, y: 0}
       }
    }

    componentDidMount() {
        //Hack: To wrap canvas only over page details container only
        this.UpdateCanvasView(false, false, false);

        const elements = document.getElementsByClassName('upper-canvas');
        Array.from(elements).forEach(element => {
            element.addEventListener('contextmenu', this.handleContextMenu);
        });
        document.addEventListener('click', this.handleOutsideClick);
    }
    
    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void{
        if (prevProps?.pageDetails?.pageNumber !== this.props.pageDetails?.pageNumber) {

            // Update Canvas Width and Height based upon the pages
            if (CustomerFalseCeilingTypes?.includes(this.props.pageDetails?.type)) {

                let widthPercentage: any = 0.75;
                let heightPercentage: any = false;

                switch (this.props.pageDetails?.type) {
                    case 'CUSTOM_FALSECEILING_OVERVIEW':
                        heightPercentage = 127;
                        break;
                    // case 'CUSTOM_FALSECEILING_PLAN': 
                    // case 'CUSTOM_FALSECEILING_LIGHT_LAYOUT':
                    // case 'CUSTOM_FALSECEILING_LOOPING_LAYOUT':
                    //     heightPercentage = 185;
                    //     break;
                    case 'CUSTOM_FALSECEILING_SECTION':
                        widthPercentage = false;
                        break;
                    case 'CUSTOM_FALSECEILING_ELECTRICAL_SOW':
                    case 'CABINET_LIGHT':
                        widthPercentage = 0.06;
                        break
                    case 'CUSTOM_SCOPE_OF_WORK_TABLE':
                        widthPercentage = 0.001;
                        break;
                    case 'WALL_ELECTRICAL':
                        widthPercentage = 0.76;
                        const dataLength = this.props.pageDetails?.electricalData?.length;
                        const rowHeight = dataLength < 4 ? 30 : dataLength < 8 ? 15 : 10;
                        const calculatedValue = dataLength * rowHeight || 130                        
                        heightPercentage = 73 + calculatedValue                            
                        break;
                    case 'DEMOLITION_ROOM':
                    case 'CIVIL_WORK':
                        widthPercentage = 1;
                        heightPercentage = 168;
                        if (this.props.pageDetails?.civilWorkDetails?.length || this.props.pageDetails?.demolitionDetails?.length) {
                            heightPercentage = 240;
                        }
                        break;
                    case 'CIVIL_FLOOR_MARBLE_LAYING':
                    case 'CIVIL_FLOOR_TILE_LAYING':
                    case 'CIVIL_WALL_TILE_LAYING':
                        widthPercentage = 1;
                        heightPercentage = 140;
                        if(['CIVIL_FLOOR_TILE_LAYING', 'CIVIL_WALL_TILE_LAYING'].includes(this.props.pageDetails?.type)) {
                            heightPercentage = 106;
                        }
                        break;
                    case 'WALL_DECOR_NEW':
                        widthPercentage = false;
                        heightPercentage = 230;
                        if(this.props.pageDetails?.wallDetails) {
                            heightPercentage = false   
                        }
                        break;
                    case 'WOODEN_FLOORING':
                        widthPercentage = false;
                        heightPercentage = 78;
                        if(this.props.pageDetails?.floorTilesMetaData?.floorDetailsList?.length) {
                            heightPercentage = 78 + this.props.pageDetails?.floorTilesMetaData?.floorDetailsList?.length * 30
                        }
                        break;
                    case 'CURTAINS':
                    case 'CURTAINS_YELLOW':
                    case 'CURTAINS_DECOR':
                    case 'CURTAINS_AUMBRE':
                        widthPercentage = false;
                        heightPercentage = 180;
                        break;
                    case'COUNTER_TOP_MATERIAL_SOW': 
                        widthPercentage = 0.001;
                        break;
                    case'RFQ': 
                        if(this.props.pageDetails?.pageType === 'RFQ') {
                            widthPercentage = 0.001;
                        } else {
                            widthPercentage = 1;
                        } 
                        break;
                    default:
                        break;
                }

                // 'WALL_ELECTRICAL', 'CABINET_LIGHT', 'WALL_DECOR_NEW', 'WOODEN_FLOORING'


                this.UpdateCanvasView(widthPercentage, heightPercentage, true)
            } else {
                this.UpdateCanvasView(false, false, true)
            }
            this.setState({
                notes: ""
            })
        }
    }

    // Lifecycle method to clean up event listeners
    componentWillUnmount() {
        const elements = document.getElementsByClassName('upper-canvas');
        Array.from(elements).forEach(element => {
            element.removeEventListener('contextmenu', this.handleContextMenu);
        });
        document.removeEventListener('click', this.handleOutsideClick);
    }

    // Function to update the Canvas Width and height
    UpdateCanvasView = (widthPercentage: any, heightPercentage: any, updateRequired: boolean) => {
        let width = window.innerWidth;
        let height = window.innerHeight;

        const container = document.getElementById('page-details-container');
        if(container){
            const containerStyle = getComputedStyle(container);
            const percentageWidth =  widthPercentage ? widthPercentage * parseInt(containerStyle.width.split("px")[0]) : parseInt(containerStyle.width.split("px")[0]);
            width = percentageWidth;
            height = heightPercentage ? parseInt(containerStyle.height.split("px")[0]) - heightPercentage : parseInt(containerStyle.height.split("px")[0]);
            console.log('this.props.fabricInstance', containerStyle.height);
        }
        
        // Checking if new canvas have to create or update canvas width and height
        updateRequired ? this.props.updateFabric(width, height) : this.props.init(width, height);
    }

    
    handleNotesUpdate = (e) => {
        try {
            let value = e.target.value;
            this.setState({
                notes: value
            })
            this.savePageNotes({notes:value});
        } catch (error) {
            console.error("Error in handleNotesUpdate",error);
        }
    }
    
    savePageNotes = debounce(this.props.setPageNotes,1500);

    renderPages(type){
        if(!type)
            return;
        try {
            const { exportDrawingStatus, isDqcDataPresent, previewMode } = this.props;
            type = type.toLowerCase();
            type = type.replace(/\d+/g, "");

            // Setting variable while preview or exporting a drawing
            const isDrawingsExporting = ( (exportDrawingStatus === 'inprogress' && isDqcDataPresent ) || (previewMode === 'enabled'))

            switch(type){
                case 'overview':
                    return <OverView pageDetails={this.props.pageDetails}  />
                case 'overviewsubpage':
                    return <OverView2 pageDetails={this.props.pageDetails} />
                case 'plan':
                    return <PlanView pageDetails={this.props.pageDetails} />
                case 'dimension':
                    return <ElevationDimensions pageDetails={this.props.pageDetails} />
                case 'material':
                case 'shutter_material':
                    return <ElevationMaterial pageDetails={this.props.pageDetails}  />
                case 'shutterextension':
                    return <ElevationShutterExtension pageDetails={this.props.pageDetails}/>
                case 'internal':
                    return <ElevationInternals pageDetails={this.props.pageDetails}  />
                case 'crosssection':
                    return <CrossSection pageDetails={this.props.pageDetails}/>
                case 'sitedetail':   
                    return <SiteDetail pageDetails={this.props.pageDetails}/>
                case 'appliances':
                    return <Appliances pageDetails={this.props.pageDetails}  />   
                case 'modulelist':
                    return <ModuleList pageDetails={this.props.pageDetails}/>
                case 'instruction':
                    return <InstructionPage pageDetails={this.props.pageDetails}  />      
                case 'electrical':
                    return <ElevationElectricals  pageDetails={this.props.pageDetails} />
                case 'plumbing':
                    return <PlumbingElectricals  pageDetails={this.props.pageDetails} /> 
                case 'wallpaperservice':
                    return <WallpaperBespoke pageDetails={this.props.pageDetails}></WallpaperBespoke>
                case 'paintingservice':
                    return <PaintingBespoke pageDetails={this.props.pageDetails}></PaintingBespoke>
                case 'flooringservice':
                    return <FlooringBespoke pageDetails={this.props.pageDetails}></FlooringBespoke>
                case 'wall_tile':
                    return <DadoTiles pageDetails={this.props.pageDetails}></DadoTiles>
                case 'bespoke':
                case 'demolition':
                case 'falseceiling':
                case 'electricalservices':
                case 'plumbingservices':
                case 'showercubicles':
                case 'drapes&upholstery':
                case 'countertopmaterial&services':
                case 'renovation':
                case 'lightingservice':
                case 'loosefurnitures':
                case 'custom_woodwork':
                    return <BespokePage pageDetails={this.props.pageDetails}/>
                case 'lightingoverview':
                    return <LightingOverView  pageDetails={this.props.pageDetails} />    
                // case 'lightingplan':
                //     return <LightingPlan  pageDetails={this.props.pageDetails} />    
                case 'lighting':
                    return <LightingPlan  pageDetails={this.props.pageDetails} />
                // case 'wallpaperelevation':
                //     return <WallpaperElevation  pageDetails={this.props.pageDetails} />   
                case "wall_decor":
                    return <PaintingElevation pageDetails={this.props.pageDetails}/>      
                case 'flooring':
                    return <Flooring pageDetails={this.props.pageDetails} />   
                case 'countertop':
                case 'countertop_elevation':
                    return <CounterTop pageDetails={this.props.pageDetails} />  
                case 'standardinstruction':
                    return <StandardInstructionPage pageDetails={this.props.pageDetails}/>
                case 'gas_outlet':
                    return <ElevationGasOutlet  pageDetails={this.props.pageDetails}/>
                case 'other_services':
                    return <OtherServices pageDetails={this.props.pageDetails}/>
                case 'falseceiling_overview':
                    return <FalseCeilingOverView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_reflectedview':
                    return <FalseCeilingReflectedView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_sectionview':
                    return <FalseCeilingSectionView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_planview':
                    return <FalseCeilingPlanView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_paintview':
                    return <FalseCeilingPaintView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_lightingview':
                    return <FalseCeilingLightingView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_electricalview':
                    return <FalseCeilingElectricalView pageDetails={this.props.pageDetails}/>
                case 'falseceiling_electrical_loopingview':
                    return <FalseCeilingElectricalLoopingView pageDetails={this.props.pageDetails} />                
                case 'loose_furniture':
                    return <LooseFurniture pageDetails={this.props.pageDetails}></LooseFurniture>
                case 'custom_falseceiling_overview':
                    return <CustomFalseCeilingOverview key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'custom_falseceiling_plan':
                    return <CustomFalseCeilingPlan key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'custom_falseceiling_section':
                    return <CustomFalseCeilingSection key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'custom_falseceiling_electrical_sow':
                    return <CustomFalseCeilingSOW key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'custom_falseceiling_light_layout':
                    return <CustomFalseCeilingLightLayout key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting} />
                case 'custom_falseceiling_looping_layout':
                    return <CustomFalseCeilingLoopingLayout key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'demolition_room':
                    return <DemolitionServicesRoom key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'civil_work':
                    return <CivilWorkServices key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'civil_floor_marble_laying':
                    return <CivilFloorMarbleLaying key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case 'civil_floor_tile_laying':
                    return <CivilFloorTileLaying key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting} />
                case 'civil_wall_tile_laying':
                    return <CivilWallTileLaying key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting} />
                case 'wall_electrical':
                    return <WallElectrical key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting} />
                case 'cabinet_light':
                    return <NewLightingOverview key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting} />
                case 'wooden_flooring':
                    return <WoodenFlooring key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting} />
                case "wall_decor_new":
                    return <WallPainting pageDetails={this.props.pageDetails}/>  
                case "custom_scope_of_work_table":
                    return <ScopeOfWorkTable key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>    
                case "wall_cladding":
                    return <WallPaneling key={this.props.pageDetails?.pageNumber} />
                case "counter_top_material_sow":
                    return <CounterTopSOW key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case "curtains":
                    return <Curtains key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case "curtains_yellow":
                    return <CurtainsYellow key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case "curtains_decor":
                    return <CurtainsDecor key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case "curtains_aumbre":
                    return <CurtainsAumbre key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case "rfq":
                    return <RFQPage key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                case "dqc":
                    return <DQCPage key={this.props.pageDetails?.pageNumber} isDrawingsExporting={isDrawingsExporting}/>
                default:
                    return <CustomView  />    
            }
        } catch (error) {
            console.error("Error in renderPage",error);
        }
    }
    handleLayering = () => {
        this.props.enableLayering(!this.props.layeringEnabled);
    }

    // Function to show the right menu option
    handleContextMenu = (event) => {
        event.preventDefault();
        const { exportDrawingStatus, isDqcDataPresent, previewMode } = this.props;
        // Disable right click menu while preview or exporting a drawing
        const isDrawingsExporting = ( (exportDrawingStatus === 'inprogress' && isDqcDataPresent ) || (previewMode === 'enabled'))
        if (isDrawingsExporting) {
            return;
        }
        this.setState({
            menubar: { x: event.pageX - parseInt(this.props.left, 10), y: event.pageY - 90 }
        })
    };

    // Function to hide menu if user click outside.
    handleOutsideClick = () => {
        if (this.state.menubar?.x) {
          this.setState({ menubar: false });
        }
      };
    
    render(){
        const { menubar } = this.state;
        const { type, customer_details, pageDetails, previewMode,exportDrawingStatus } = this.props;        
        const notesVisible = !['overview', 'instruction','standardInstruction','overviewSubPage', 'custom_woodwork'].includes(type?.toLowerCase());
        return(
            <>
            {/* <LayerIcon style={{position:'absolute',left:20,top:20,zIndex:1000}} onClick={() => this.handleLayering()}></LayerIcon> */}
            <div id={'mainPageDiv'} className="page-div" onClick={() => menubar ? this.setState({menubar: ''}) : ''}>
                
                <div  id='pageContainer' className="page-container floating-div">
                
                    {previewMode ==='enabled' &&
                    <React.Fragment>
                        <ErrorComponent/>
                        <WaterMark message={"PREVIEW ONLY"}/>
                    </React.Fragment>
                    }
                    {
                        pageDetails?.name?.includes("OLD PAGE") && 
                        <React.Fragment>
                            <WaterMark message={"OLD PAGE"}/>
                        </React.Fragment>
                    }
                    <div className="page-left-container">
                        
                        <canvas id='2DD' style={{top: "25px"}}/>
                        <div id='page-details-container' className={notesVisible?'details-container':'details-container-without-notes'}>
                            {this.renderPages(type)}
                        </div>  
                        <div className="note-container" style={notesVisible?{height:"15%"}:{height:"6%"}}>  
                            {notesVisible
                                ? (previewMode === 'enabled' && !pageDetails?.notes) ? "": <>
                                    <div className="note-heading">NOTE</div>
                                    
                                    {(exportDrawingStatus === 'pending'|| previewMode === 'enabled')?
                                    <div className="note-textarea" style={{height:"56px"}} contentEditable={true} dangerouslySetInnerHTML={{__html:pageDetails?.notes?.replace(/\n/g, "<br/>")}}></div>
                                    :<textarea data-page-id={pageDetails?.pageNumber} 
                                        className="note-textarea"
                                        value={this.state?.notes || pageDetails?.notes} cols={100} rows={2} 
                                        placeholder="Click to Enter Text" 
                                        onChange={(e)=>this.handleNotesUpdate(e)}>
                                        {pageDetails?.notes}
                                    </textarea>}
                                </>
                                :null
                            }
                            <div className="page-botton-footer">
                                <span>{`PAGE - ${pageDetails?pageDetails.pageNumber:0}`}</span>
                                <span className="footer-span">
                                    {this.props.orderProfileTitle} Proprietary - Not to be distributed without prior permission.
                                </span>
                            </div>
                        </div>
                        <QRCodeCanvas value={`${this.props.projectData?.opportunityId}:${pageDetails?.pageNumber}`} size={80} style={{position:'absolute', right:'4px', bottom:'10px'}} />
                    </div>
                    <CustomerDetailsContainer customerDetails={customer_details} roomName={""}  type = {type}/>
                    {
                        this.state.menubar?.y ?
                            <RightClickMenu top={this.state.menubar?.y} left={this.state.menubar?.x} />
                            : ''
                    }
                 </div>
            </div>
            </>
           
        )
    }

}
export default connect(
    (state: any) => ({
        customer_details: state.wizard.customer_details,
        projectData: state.wizard.projectData,
        pageDetails: state.wizard.pageDetails,
        toolEnabled: state.wizard.toolEnabled,
        previewMode: state.wizard.previewMode,
        exportDrawingStatus:state.wizard.exportDrawingStatus,
        layeringEnabled:state.wizard.layeringEnabled,
        fabricInstance: state.wizard.fabricInstance,
        isDqcDataPresent:state.wizard.isDqcDataPresent,
        orderProfileTitle:state.wizard.orderProfileTitle,
    }),
    {
        init,
        setPageNotes,
        enableLayering,
        updateFabric
    }
)(PageContainer);